<template>
    <div class="copy-sku clearfix">
        <div class="info margin-left-15 margin-top-10 margin-bottom-15">
            <p>注意事项</p>
            <p>1.建议同项目的SKU进行复制</p>
            <p>2.复制后数据直接覆盖SKU原有配置，请确认清楚再操作</p>
            <p>3.最多一次复制50条</p>
        </div>
        <div>
            <Form :labelWidth="73" :model="formData" >
                <FormItem label="ERP SKU" prop="erpsku">
                    <Input :rows="5" v-model="formData.erpsku" type="textarea" />
                </FormItem>
            </Form>
        </div>
        <div class="pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">提交</Button>
            <Button @click="cancel">取消</Button>
        </div>
        <Spin fix v-if="loading"></Spin>
    </div>
</template>
<script>
import {
    HttpCopySKU
} from "@/service/stockdistribution/index";
export default {
    props: ['activeid'],
    data () {
        return {
            formData: {},
            loading: false
        }
    },
    methods: {
        cancel () {
            this.$emit('on-close');
        },
        async submit () {
            if (!this.formData.erpsku) return this.$VMessage.warning("erpsku不能为空");
            this.loading = true;
            await HttpCopySKU({
                id: this.activeid,
                erpSku: this.formData.erpsku.split('\n')
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
    }
}
</script>

<style>

</style>